import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";

// Os 3 aparelhos com mais contatos no WhatsApp nos últimos 7 dias (mínimo 2). Buscado uma vez por visita.
let cache = null;
let request = null;

const useTopContacted = () => {
  const [ids, setIds] = useState(cache || []);
  useEffect(() => {
    let alive = true;
    if (!request) request = api.get("/top-contacted").then((r) => (Array.isArray(r?.data?.ids) ? r.data.ids : [])).catch(() => []);
    request.then((v) => {
      cache = v;
      if (alive) setIds(v);
    });
    return () => { alive = false; };
  }, []);
  return ids;
};

const SIZES = {
  sm: "gap-1 px-2 py-0.5 text-[10px]",
  md: "gap-1.5 px-3 py-1 text-[11px]",
  lg: "gap-1.5 px-3 py-1 text-sm",
};

export const HotBadge = ({ id, size = "md", className = "" }) => {
  const ids = useTopContacted();
  if (!id || !ids.includes(id)) return null;
  return (
    <span data-testid={`hot-badge-${id}`} className={`pointer-events-none inline-flex items-center rounded-full bg-orange-500 font-bold uppercase tracking-[0.06em] text-black ${SIZES[size]} ${className}`}>
      <Flame className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} strokeWidth={2.4} /> Mais procurado
    </span>
  );
};
